import i18next from 'i18next';

/** Маппинг кода языка → Intl-локаль (используется для Intl.DateTimeFormat) */
const INTL_LOCALES: Record<string, string> = {
  ru: 'ru-RU',
};

function getIntlLocale(): string {
  const lang = i18next.language || 'ru';
  return INTL_LOCALES[lang] ?? 'ru-RU';
}

/** Возвращает Intl-локаль для текущего языка приложения */
export function getCurrentIntlLocale(): string {
  return getIntlLocale();
}

/**
 * Форматирует дату в формат "DD месяц YYYY" или "DD месяц" (без года)
 * @param date - дата для форматирования (объект Date или ISO строка)
 * @param options - дополнительные опции форматирования
 * @param options.short - если true, выводит без года (например "5 мар.")
 * @returns отформатированная строка даты
 */
export function formatDate(
  date: Date | string,
  options?: { short?: boolean },
): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const formatOptions: Intl.DateTimeFormatOptions = options?.short
    ? { day: 'numeric', month: 'short' }
    : { day: 'numeric', month: 'long', year: 'numeric' };

  // Используем Intl.DateTimeFormat для корректного склонения месяца
  const formatter = new Intl.DateTimeFormat(getIntlLocale(), formatOptions);

  return formatter.format(dateObj);
}